import { useAppSelector } from 'src/hooks';
import { RootState } from 'src/redux/reducers/rootReducer';
import { useAccountApproved } from './useAccountApproved';
import { useProductActive } from './useProductActive';

export const useCheckBridged = () => {
  const b2xUser = useAppSelector((state: RootState) => state.main.b2xUser);
  const { isOverdraftProductActive, isBridgedActive } = useProductActive();
  const isAccountApproved = useAccountApproved();

  const showBridged =
    b2xUser.overdraft_balance !== 0 &&
    (isOverdraftProductActive || isBridgedActive) &&
    isAccountApproved;

  return { showBridged };
};
